/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   Hook to get messaged listings and buildings from state or localStorage
 */

import type { Bundle } from '@zcode/bizos'
import { localStorageSingleton } from '@zcode/nr-utils'
import { selectIsLoggedIn } from '@zcode/nr/es/shared/modules/user/selectors'
import type { Property } from '@zcode/state-type'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getEntityIsMessaged, getMessaged } from '../../../inspectors'

export const useMessaged = () => {
  const bundleMessaged = useSelector(getMessaged)
  const lsMessaged = (localStorageSingleton.get('messaged') as unknown as Bundle['messaged']) ?? {
    listings: {},
    buildings: {},
  }
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const messaged = isLoggedIn ? bundleMessaged : lsMessaged
  const isMessaged = useCallback(
    (entity: Pick<Property, 'buildingId' | 'listingId' | 'pbId' | 'plId'> | null | undefined) => {
      return entity ? getEntityIsMessaged(messaged, entity) : false
    },
    [messaged]
  )
  return { messaged, isMessaged }
}
